import { render, staticRenderFns } from "./Profiel.vue?vue&type=template&id=267e1e94&"
import script from "./Profiel.vue?vue&type=script&lang=js&"
export * from "./Profiel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/vhosts/beheer.p4.shifft.com/httpdocs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCardActions,VCardText,VCol,VContainer,VDivider,VFlex,VIcon,VLayout,VRow,VSimpleTable,VSnackbar,VSpacer,VTextField})
